/* Millesève — parallaxe des photos PORTRAIT (DS §8) : l'image, haute de 112 %, glisse de ±--parallax-range
   au scroll, un peu moins vite que la page. Rien quand le mouvement est réduit (jeton à 0 %). */
if (!customElements.get('ms-parallaxe')) {
  const elements = new Set();
  let tick = 0;
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');

  const bouge = () => {
    tick = 0;
    const vh = window.innerHeight;
    for (const el of elements) {
      const amplitude = parseFloat(getComputedStyle(el).getPropertyValue('--parallax-range')) || 0;
      if (reduit.matches || !amplitude) {
        el.style.transform = '';
        continue;
      }
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -120 || r.top > vh + 120) continue;
      const p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2)));
      el.style.transform = `translate3d(0, ${(-p * amplitude).toFixed(2)}%, 0)`;
    }
  };
  const demande = () => {
    if (!tick) tick = requestAnimationFrame(bouge);
  };

  window.addEventListener('scroll', demande, { passive: true });
  window.addEventListener('resize', demande);
  reduit.addEventListener('change', demande);

  customElements.define(
    'ms-parallaxe',
    class extends HTMLElement {
      connectedCallback() {
        elements.add(this);
        demande();
      }
      disconnectedCallback() {
        elements.delete(this);
      }
    }
  );
}
